// Slide-friendly wrapper that mounts any registered Tier 2 simulator by
// kind. Consumers pass `kind="<id>"` plus pass-through props for that
// simulator (initialState, onAction, onStateChange). Read-only embeds
// simply omit `onAction`. Drill components (e.g. CleanTakeDrill) pipe
// `onAction` through to score against a cue sequence.

import { SIMULATORS, type SimulatorKind } from "./simulators";

interface EquipmentSimulatorProps {
  kind: SimulatorKind;
  /**
   * Pass-through props for the target simulator. Shape is simulator-
   * specific (e.g. Crossover Solo expects `{ pgm?, pvw? }`); callers
   * are responsible for matching the kind to a known shape. Unknown
   * keys are silently ignored by the panel.
   */
  initialState?: Record<string, unknown>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onAction?: (action: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onStateChange?: (state: any) => void;
}

export default function EquipmentSimulator({
  kind,
  initialState,
  onAction,
  onStateChange,
}: EquipmentSimulatorProps) {
  const entry = SIMULATORS[kind];
  if (!entry) {
    return (
      <div role="alert" style={{ padding: 12, color: "#ff5566" }}>
        Unknown simulator kind: <code>{kind}</code>
      </div>
    );
  }
  const { Component } = entry;
  return (
    <Component
      initialState={initialState}
      onAction={onAction}
      onStateChange={onStateChange}
    />
  );
}
